export const activeFilters = ({ templateFilters }) => templateFilters.byId;
